import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import MediaLog from './media-log-model'
import {
  CreateMediaLogAsync,
  DeleteMediaLogAsync,
  LoadMediaLogsAsync,
} from './mediaLog-thunk'
const initialState: mediaLogSliceState = {
  mediaLog: [],
  selected_mediaLog: '',
  is_loading_mediaLog: false,
  is_creating_mediaLog: false,
  is_deleting_mediaLog: false,
}
export interface mediaLogSliceState {
  mediaLog: MediaLog[]
  selected_mediaLog?: string
  is_loading_mediaLog: boolean
  is_creating_mediaLog: boolean
  is_deleting_mediaLog: boolean
}
export const mediaLogSlice = createSlice({
  name: 'mediaLog',
  initialState,
  reducers: {
    setSelectedmediaLog: (state, action) => {
      state.selected_mediaLog = action.payload
    },
    clearStatemediaLog: (state) => {
      state.mediaLog = []
      state.is_loading_mediaLog = false
      state.is_creating_mediaLog = false
      state.is_deleting_mediaLog = false
    },
    mergemediaLog: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_mediaLog = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.mediaLog = merge(state.mediaLog, payload) as any
        }
      }
    },

    add_mediaLog: (state, action) => {
      if (action.payload) {
        state.mediaLog = [...state.mediaLog, action.payload]
      }
    },
    set_mediaLog: (state, action) => {
      let { key, value, id } = action.payload
      state.mediaLog = state.mediaLog.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadMediaLogsAsync.pending, (state) => {
      state.is_loading_mediaLog = true
    })
    builder.addCase(LoadMediaLogsAsync.fulfilled, (state, action) => {
      state.is_loading_mediaLog = false
      if (action.payload) {
        state.mediaLog = action.payload
      }
    })
    builder.addCase(LoadMediaLogsAsync.rejected, (state) => {
      state.is_loading_mediaLog = false
    })
    builder.addCase(CreateMediaLogAsync.pending, (state) => {
      state.is_creating_mediaLog = true
    })
    builder.addCase(CreateMediaLogAsync.fulfilled, (state) => {
      state.is_creating_mediaLog = false
    })
    builder.addCase(CreateMediaLogAsync.rejected, (state) => {
      state.is_creating_mediaLog = false
    })
    builder.addCase(DeleteMediaLogAsync.pending, (state) => {
      state.is_deleting_mediaLog = true
    })
    builder.addCase(DeleteMediaLogAsync.fulfilled, (state, action) => {
      state.is_deleting_mediaLog = false
      if (state.mediaLog) {
        state.mediaLog = state.mediaLog.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteMediaLogAsync.rejected, (state) => {
      state.is_deleting_mediaLog = false
    })
  },
})

export const {
  clearStatemediaLog,
  setSelectedmediaLog,
  set_mediaLog,
  mergemediaLog,
  add_mediaLog,
} = mediaLogSlice.actions

export const get_mediaLog =
  (id?: string) =>
  (state: {
    mediaLog: {
      mediaLog: MediaLog[]
    }
  }): MediaLog | null => {
    let temp = state?.mediaLog?.mediaLog?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.mediaLog?.mediaLog[0] || null
  }
export const get_selected_mediaLog = (state: {
  mediaLog: mediaLogSliceState
}): MediaLog | null => {
  let id = state?.mediaLog?.selected_mediaLog
  let temp = state?.mediaLog?.mediaLog?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_mediaLog = (state: {
  mediaLog: {
    mediaLog: MediaLog[]
  }
}): MediaLog[] => {
  let temp = state?.mediaLog?.mediaLog
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_mediaLog_busy = (state: { mediaLog: mediaLogSliceState }) => {
  return (
    state?.mediaLog.is_deleting_mediaLog ||
    state?.mediaLog.is_loading_mediaLog ||
    state?.mediaLog.is_creating_mediaLog
  )
}
export const is_deleting_mediaLog_busy = (state: {
  mediaLog: mediaLogSliceState
}) => {
  return state?.mediaLog.is_deleting_mediaLog
}
export const is_loading_mediaLog_busy = (state: {
  mediaLog: mediaLogSliceState
}) => {
  return state?.mediaLog.is_loading_mediaLog
}
export const is_creating_mediaLog_busy = (state: {
  mediaLog: mediaLogSliceState
}) => {
  return state?.mediaLog.is_creating_mediaLog
}

export default mediaLogSlice.reducer
